/*
 * sticky-atc-bridge.js — rachev
 * Bridges the floating sticky ATC (and any [id^="SectionAtcBtn-"] button) to
 * the ONE real cart wiring: the main <product-form data-main="true"> handler.
 *
 * Responsibilities:
 *   1. Wire every [id^="SectionAtcBtn-"] click -> productForm.handleSubmit(e).
 *   2. Keep the sticky button's enabled/disabled state in sync with the main
 *      ATC submit button.
 *   3. A MutationObserver guard preserves the sticky button label so other
 *      scripts can't blank it out.
 *
 * Reacts to the shared qb:state-changed contract only to keep the button
 * enabled state fresh after a tier change (price text is owned by
 * price-manager.js — this file never writes prices).
 */
(function () {
  'use strict';

  if (window.__stickyAtcBridgeInit) return;
  window.__stickyAtcBridgeInit = true;

  function getMainForm() {
    return (
      document.querySelector('product-form[data-main="true"]') ||
      document.querySelector('product-form') ||
      null
    );
  }

  function getMainSubmit() {
    return (
      document.querySelector('product-form[data-main="true"] button[type="submit"]') ||
      document.querySelector('.product-form button[type="submit"][name="add"]') ||
      document.querySelector('.product-form button[type="submit"]') ||
      null
    );
  }

  // ---- 1. Wire sticky / section ATC buttons to the main form handler ----
  function wireButtons() {
    var productForm = getMainForm();
    document.querySelectorAll('[id^="SectionAtcBtn-"]').forEach(function (btn) {
      if (btn.dataset.qbBridged === 'true') return;
      btn.dataset.qbBridged = 'true';

      // Bundle buttons have their own /cart/add.js handler — leave them alone.
      if (btn.classList.contains('atc-bundle-btn')) return;

      btn.addEventListener('click', function (e) {
        var form = getMainForm();
        if (form && typeof form.handleSubmit === 'function') {
          e.preventDefault();
          form.handleSubmit(e);
        } else {
          // Fallback: trigger the real submit button.
          var submit = getMainSubmit();
          if (submit) submit.click();
        }
      });

      guardLabel(btn);
    });
    return productForm;
  }

  // ---- 2. Sync enabled/disabled with the main submit button ----
  function syncDisabledState() {
    var mainSubmit = getMainSubmit();
    if (!mainSubmit) return;
    var disabled = mainSubmit.disabled || mainSubmit.getAttribute('aria-disabled') === 'true';

    document.querySelectorAll('[id^="SectionAtcBtn-"]').forEach(function (btn) {
      if (btn.classList.contains('atc-bundle-btn')) return;
      btn.disabled = disabled;
      if (disabled) {
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.removeAttribute('aria-disabled');
      }
    });
  }

  function observeMainSubmit() {
    var mainSubmit = getMainSubmit();
    if (!mainSubmit) return;
    var mo = new MutationObserver(syncDisabledState);
    mo.observe(mainSubmit, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
    syncDisabledState();
  }

  // ---- 3. MutationObserver guard for the sticky button label ----
  function guardLabel(btn) {
    var labelEl =
      btn.querySelector('.sticky-atc__label__text') ||
      btn.querySelector('.button__label');
    if (!labelEl) return;

    var saved = (labelEl.textContent || '').trim();
    if (!saved) return;
    labelEl.dataset.qbLabel = saved;

    var mo = new MutationObserver(function () {
      var current = (labelEl.textContent || '').trim();
      if (!current && labelEl.dataset.qbLabel) {
        labelEl.textContent = labelEl.dataset.qbLabel;
      }
    });
    mo.observe(labelEl, { childList: true, characterData: true, subtree: true });
  }

  function boot() {
    wireButtons();
    observeMainSubmit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Keep button state fresh after a tier change.
  document.addEventListener('qb:state-changed', syncDisabledState);

  // Re-wire on Theme Editor block load.
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', boot);
  }
})();
